module.exports = __webpack_public_path__ + "static/bluestripehampermain-d85027f13bbd9ed774c98db455419431.jpeg";